var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiSrMenuBurger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3043 7.30469H0.695641C0.311445 7.30469 0 7.61613 0 8.00033C0 8.38452 0.311445 8.69597 0.695641 8.69597H15.3043C15.6885 8.69597 16 8.38452 16 8.00033C16 7.61613 15.6885 7.30469 15.3043 7.30469Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.695641 3.82585H15.3043C15.6885 3.82585 16 3.51441 16 3.13021C16 2.74602 15.6885 2.43457 15.3043 2.43457H0.695641C0.311445 2.43457 0 2.74602 0 3.13021C0 3.51441 0.311445 3.82585 0.695641 3.82585Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3043 12.1738H0.695641C0.311445 12.1738 0 12.4853 0 12.8695C0 13.2537 0.311445 13.5652 0.695641 13.5652H15.3043C15.6885 13.5652 16 13.2537 16 12.8695C16 12.4853 15.6885 12.1738 15.3043 12.1738Z",
    fill: "currentcolor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrMenuBurger);
export default __webpack_public_path__ + "static/media/fi-sr-menu-burger.31c1d9a4aa37d36b93275c7778a70f52.svg";
export { ForwardRef as ReactComponent };